import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCountryInfo, getCurrencySymbol } from '../lib/currenyUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getInitialsName } from '../lib/utils';
import {
    encryptPayload
} from '../utils/encryption';
import { ArrowRight,ArrowLeft } from 'lucide-react';

function PaymentConfirmation() {
  const fileInputRef = useRef(null);

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };
  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state;
  console.log('Params Data', paramsdata);
  const name = paramsdata.name;
  const ifsc = paramsdata.ifsc;
  const account = paramsdata.account;
  // const type = paramsdata.bank_type;
  const id = paramsdata.id;
  const bank_account_name = paramsdata.bank_account_name;
  const currencyid = paramsdata.currencyid;
  const currency = paramsdata.currency;
  const amount = paramsdata.amount;
  const bank_account_id = paramsdata.bank_account_id;
  const country = paramsdata.country;
  const bene_type = paramsdata.bene_type;
  const bank_type = paramsdata.bank_type;
  const Nav_node = paramsdata.Nav_node;
  const payment_type = paramsdata.payment_type;
  const balance = paramsdata.balance;

  const [defaultBank, setDefaultBank] = useState('');
  const [transferReason, settransferReason] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [transferReasons, setTransferReasons] = useState([]);
  const [ref, setRef] = useState('');
  const [notes, setNotes] = useState();
  const [files, setFiles] = useState([]);
  const [clearBankBalance, setclearBankBalance] = useState(0.0);
  const [currencyCloudBalance, setcurrencyCloudBalance] = useState(0.0);
  const [clearBankConfiguration, setclearBankConfiguration] = useState();
  const [transacitonfees, setTransactionFees] = useState();
  const [userType, setUserType] = useState();

  console.log('bank_type:', bank_type);
  console.log('currencyid:', currencyid);
  console.log("payment confirmation params data", paramsdata);

  const setReasonForTransfer = async (val) => {
    settransferReason(val);
  };

  useEffect(() => {
    setAsyncData();
    loadBalances();
  }, []);

  const setAsyncData = async () => {
    sessionStorage.setItem('beneficiary_id', JSON.stringify(id));
    sessionStorage.setItem('beneficiary_bank_account_name', bank_account_name);
    setTransferReasons(JSON.parse(sessionStorage.getItem('transfer_reasons')));

    const storeddefaultBank = sessionStorage.getItem('defaultBank');
    setDefaultBank(storeddefaultBank);
    console.log('Default Bank', storeddefaultBank);
    const parsedWorkspace = JSON.parse(sessionStorage.getItem('login_workspaces'));
    var ref = '';
    if (storeddefaultBank === 'Clear Bank as Service') {
      console.log('cb');
      setRef('');
    } else {
      if (parsedWorkspace && Object.keys(parsedWorkspace[0].accounts || {}).length > 0) {
        console.log('cc');
      } else {
        ref = JSON.parse(sessionStorage.getItem('login_workspaces'))[0].memberships.urn;
        setRef(ref);
      }
    }
  };

  const loadBalances = async () => {
    setButtonLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const token = sessionStorage.getItem('login_token');
    const workspace = sessionStorage.getItem('login_workspaces');
    if (workspace) {
      const parsedWorkspace = JSON.parse(workspace);
      setUserType(parsedWorkspace[0].type);
    }
    var balanceUrl =
      Constants.BASE_URL + 'API-FX-231-GET-WALLET-BALANCES/' + login_workspaces_id + '?currency=' + currency;
    const resp = await axios.get(balanceUrl, {
      headers: {
        Authorization: 'Bearer ' + JSON.parse(token),
        fx_key: Constants.SUBSCRIPTION_KEY,
      },
    });
    var transactionFee = 0;
    transactionFee =
      Object.prototype.hasOwnProperty.call(resp.data.fees_configuration, 'transaction_fees') &&
      resp.data.fees_configuration.transaction_fees.percentage;
    setTransactionFees(transactionFee);
    console.log(transactionFee);
    setButtonLoading(false);
  };

  const initiateTransaction = async () => {
    try {
      setButtonLoading(true);
      const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
      const token = sessionStorage.getItem('login_token');
      const workspace = sessionStorage.getItem('login_workspaces');
      const parsedWorkspace = JSON.parse(workspace);
      const login_full_name = parsedWorkspace[0].name;
      const staff_login_id = sessionStorage.getItem('staff_login_id');

      if (!transferReason || transferReason.trim() === '') {
        toast.error('Please select transfer reason');
        setButtonLoading(false);
        return;
      }
      if (!bank_account_id) {
        toast.error('Please select a bank account for the beneficiary.');
        setButtonLoading(false);
        return;
      }
      const balanceUrl =
        Constants.BASE_URL + 'API-FX-231-GET-WALLET-BALANCES/' + login_workspaces_id + '?currency=' + currency;
      const resp = await axios.get(balanceUrl, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      });
      console.log('Wallet API Response:', resp.data);
      const balArray = Object.values(resp.data).filter((item) => item && typeof item === 'object');
      const wallet = balArray.find((balance) => balance.id == currencyid || balance.currency === currency);
      if (!wallet) {
        toast.error('Wallet for selected currency not found');
        setButtonLoading(false);
        return;
      }
      console.log('Selected Wallet:', wallet);
      const fetchedClearBankBalance = parseFloat(wallet.balance) || 0;
      const fetchedCurrencyCloudBalance = parseFloat(resp.data.currency_cloud_account_balance) || 0;
      console.log('ClearBank Balance:', fetchedClearBankBalance);
      console.log('CurrencyCloud Balance:', fetchedCurrencyCloudBalance);
      console.log('Fees Config:', resp.data.fees_configuration);
      setcurrencyCloudBalance(fetchedCurrencyCloudBalance);
      setclearBankBalance(fetchedClearBankBalance);
      setclearBankConfiguration(resp.data.fees_configuration);
      const feePercent = parseFloat(transacitonfees) || 0;
      const numericAmount = parseFloat(amount) || 0;
      const totalAmount = numericAmount + (numericAmount * feePercent) / 100;
      console.log('Amount:', numericAmount);
      console.log('Fee %:', feePercent);
      console.log('Total Required:', totalAmount);
      console.log('Balance:', fetchedClearBankBalance);
      if (!fetchedClearBankBalance || fetchedClearBankBalance <= 0) {
        toast.error('Unable to fetch ClearBank balance');
        setButtonLoading(false);
        return;
      }
      if (fetchedClearBankBalance < totalAmount) {
        toast.error('Insufficient funds');
        setButtonLoading(false);
        return;
      }

      const encryptedPayload = await encryptPayload({
          workspaceId: login_workspaces_id,
          beneficiaryId: String(id),
          beneficiaryBankId: String(bank_account_id),
          reference: ref !== '' ? ref : login_full_name,
          reason: transferReason,
          amount: numericAmount,
          currency: currency,
          type: bene_type ?? bank_type,
          staff_login_id: staff_login_id,
          total_balance: fetchedClearBankBalance,
          currency_cloud_balance: fetchedCurrencyCloudBalance,
          clear_bank_balance: fetchedClearBankBalance,
          platform: 'web',
          extraParamValidation: 'trustedfromweb'
        });


      const transactionResp = await axios.post(
        Constants.BASE_URL + 'API-FX-189-CLEAR-BANK-CREATE-TRANSACTION',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      );
      console.log('Transaction Response:', transactionResp.data);
      if (files.length > 0) {
        handleSubmit(transactionResp.data.data.id);
      }
      setButtonLoading(false);
      navigate('/PaymentSuccess');
    } catch (err) {
      console.log('Transaction Error:', err?.response?.data || err);
      toast.error(err?.response?.data?.message || 'Transaction failed');
      setButtonLoading(false);
    }
  };

  const initiateWalletTransaction = async () => {
    setButtonLoading(true);
    sessionStorage.removeItem('transfer_reason');
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const token = sessionStorage.getItem('login_token');
    const workspace = sessionStorage.getItem('login_workspaces');
    const parsedWorkspace = JSON.parse(workspace);
    const login_full_name = parsedWorkspace[0].name;
    const staff_login_id = sessionStorage.getItem('staff_login_id');

    if (transferReason != null && transferReason != '') {
      var balanceUrl =
        Constants.BASE_URL + 'API-FX-231-GET-WALLET-BALANCES/' + login_workspaces_id + '?currency=' + currencyid;
      const resp = await axios.get(balanceUrl, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      });
      console.log('Wallet API Response:', resp.data);
      const balArray = Object.values(resp.data).filter((item) => item && typeof item === 'object');
      var usedbalances = resp.data.used_balances || {};
      setcurrencyCloudBalance(parseFloat(resp.data.currency_cloud_account_balance) || 0);
      setclearBankBalance(parseFloat(resp.data.clear_bank_account_balance) || 0);
      setclearBankConfiguration(resp.data.fees_configuration);
      console.log('clearbank' + clearBankBalance);
      console.log('currency' + currencyCloudBalance);
      console.log('clearBankConfiguration' + clearBankConfiguration);
      const wallet = balArray.find((balance) => balance.id == currencyid || balance.currency === currency);
      if (!wallet) {
        toast.error('Wallet for selected currency not found');
        setButtonLoading(false);
        return;
      }
      console.log('Selected Wallet:', wallet);
      var usedbalance = 0;
      const key = getKeyByValue(Object.keys(usedbalances), currencyid);
      if (key != null && key != '' && key != 'undefined')
        usedbalance = parseFloat(Object.values(usedbalances)[key]) || 0;
      var availableBalance = parseFloat(wallet.balance) - usedbalance;
      if (availableBalance < 0) availableBalance = 0;
      if (
        availableBalance == null ||
        availableBalance === '' ||
        availableBalance === 'NaN' ||
        availableBalance === 'undefined'
      )
        availableBalance = 0;
      console.log('Available Balance for transaction:', availableBalance);

      const encryptedPayload = await encryptPayload({
            workspaceId: login_workspaces_id,
            currency: currency,
            amount: parseFloat(amount),
            paymentMethod: 'manual_transfer',
            beneficiaryId: String(id),
            reference: ref != '' ? ref : login_full_name,
            reason_code: currency == 'INR' ? transferReason.split('_')[0] : transferReason,
            reason: currency == 'INR' ? transferReason.split('_')[1] : transferReason,
            staff_login_id: staff_login_id,
            total_balance: availableBalance,
            currency_cloud_balance: currencyCloudBalance,
            clear_bank_balance: availableBalance,
            platform: 'web',extraParamValidation: 'trustedfromweb'
          });

      await axios
        .post(
          Constants.BASE_URL + 'API-FX-233-CREATE-WALLET-TRANSACTION',
          encryptedPayload          ,
          {
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
              Authorization: 'Bearer ' + JSON.parse(token),
            },
          },
        )
        .then((resp) => {
          console.log('Wallet Transaction Created:', resp.data);
          if (files.length > 0) {
            handleSubmit(resp.data.transaction.id);
          }
          setButtonLoading(false);
          navigate('/PaymentSuccess');
        })
        .catch((err) => {
          console.log('Wallet Transaction Error:', err?.response?.data || err);
          toast.error(err?.response?.data?.message || 'Transaction failed');
          setButtonLoading(false);
        });
    } else {
      toast.error('Please select transfer reason');
      setButtonLoading(false);
    }
  };

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }

  const handleSingleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    setFiles((prev) => [...prev, ...newFiles]);
    event.target.value = '';
  };

  const getBase64 = async (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  function handleSubmit(transactionId) {
    files.forEach((f) => {
      getBase64(f, (result) => {
        uploadSingleDocument(result, transactionId, f);
      });
    });
  }

  const uploadSingleDocument = async (document, transactionId, f) => {
    if (notes !== '' && notes !== null && !f) {
      toast.error('File upload is mandatory');
      return;
    }
    if (f) {
      const token = sessionStorage.getItem('login_token');
      var extension = f.name.split('.');
      console.log(extension[extension.length - 1]);
      await axios
        .post(
          Constants.BASE_URL + 'API-FX-195-UPLOAD-USER-TRANSACTION-DOCUMENTS',
          {
            document: document,
            transaction_id: transactionId,
            notes: notes == '' || notes == null ? 'NA' : notes,
            extension: extension[extension.length - 1],
          },
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        )
        .then((response) => {
          console.log(response.data);
        })
        .catch((err) => {
          err;
        });
    }
  };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const getConfirmHandler = () => {
    // if (ref !== '' && ref !== null) return initiateWalletTransaction;
    // if (defaultBank === 'currency_cloud' && currencyid !== 105 && (ref === '' || ref === null)) return initiateWalletTransaction;
    if (defaultBank === 'Clear Bank as Service' && currencyid==231 && payment_type!='priority') return initiateTransaction;
    else
    return initiateWalletTransaction;
    // if (currencyid === 105 && (ref === '' || ref === null)) 
    // return null;
  };

  const confirmHandler = getConfirmHandler();

  const isFormReady =
    transferReason.trim() !== '' &&
    (currency !== 'GBP' || (ref && ref.trim() !== ''));

  // UK sort codes display as 04-00-04 (display only; the raw code is still sent to the API)
  const isUkGbp =
    String(currency || '').toUpperCase() === 'GBP' &&
    ['GB', 'GBR', 'UK', 'UNITED KINGDOM'].includes(String(country || '').trim().toUpperCase());
  const sortCodeDigits = String(ifsc || '').replace(/\D/g, '');
  const displayCode =
    isUkGbp && sortCodeDigits.length === 6
      ? sortCodeDigits.replace(/(\d{2})(\d{2})(\d{2})/, '$1-$2-$3')
      : ifsc;

  const beneficiaryRows = [
    { label: 'Beneficiary Name', value: name || null },
    { label: 'Account Number / IBAN', value: account || null },
    { label: 'Code', value: displayCode || null },
    { label: 'Type', value: bene_type || null },
    { label: 'Country', value: country || null },
  ].filter((row) => row.value);

  const feeAmount =
    transacitonfees && amount
      ? parseFloat((amount * transacitonfees) / 100).toFixed(2)
      : null;
  const totalAmount =
    transacitonfees && amount
      ? numberWithCommas(parseFloat(amount + (amount * transacitonfees) / 100).toFixed(2))
      : null;

  const transferRows = [
    {
      label: 'Send Amount',
      value: amount ? `${getCurrencySymbol(currency)} ${numberWithCommas(parseFloat(amount).toFixed(2))}` : null,
    },
    { label: 'Currency', value: currency || null },
    {
      label: 'Transfer Fee',
      value: feeAmount ? `${getCurrencySymbol(currency)} ${feeAmount}` : null,
    },
    {
      label: 'Total Amount to Pay',
      value: totalAmount ? `${getCurrencySymbol(currency)} ${totalAmount}` : null,
      bold: true,
    },
  ].filter((row) => row.value);

  return (
    <div style={styles.page}>
      <ToastContainer />

      <p style={styles.pageTitle}>Account Review</p>
      <p style={styles.pageSubtitle}>Review of sending details</p>

      <div style={{ width: '672px' }}>
        <button onClick={() => navigate('/SendMoney',{
          state:{
            currency:currency,
            currencyid: currencyid,
            balance: balance,
            transferflowamount: null,
            Nav_node: Nav_node,
            preservedAmount: amount,
          }
        })} style={styles.backBtn}>
          <ArrowLeft className='w-5 h-5 -mr-1.5'/>
          Back
        </button>
      </div>

      <div style={styles.card}>

        {/* Recipient header */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', width: '100%' }}>
          <div style={styles.avatar}>{getInitialsName(name)}</div>
          <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ ...styles.recipientName, whiteSpace: 'normal', wordBreak: 'break-word', height: 'auto' }}>
                {name}
              </span>
              <span style={{ flexShrink: 0 }}>
                {getCountryInfo(currency, { className: 'w-5 h-5' }).flag}
              </span>
            </div>
            <div style={{ ...styles.recipientSub, width: '100%', height: 'auto' }}>
              {account}{displayCode ? ` (${displayCode})` : ''}
            </div>
          </div>
        </div>

        <div style={{ gap: '16px', width: '624px', display: 'flex', flexDirection: 'column' }}>

          <div style={{ ...styles.detailsCard, height: 'auto' }}>

            {/* Beneficiary Details */}
            <p style={styles.sectionTitle}>Beneficiary Details</p>
            <table style={{ ...styles.detailTable, height: 'auto' }}>
              <tbody>
                {beneficiaryRows.map((row, i) => (
                  <tr
                    key={row.label}
                    style={{
                      ...styles.tableRow,
                      borderBottom: i === beneficiaryRows.length - 1 ? 'none' : undefined,
                    }}
                  >
                    <td style={styles.tdLabel}>{row.label}</td>
                    <td style={{ ...styles.tdValue, fontWeight: row.bold ? 700 : 600 }}>
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Transfer Details */}
            <p style={{...styles.sectionTitle, marginTop: 4}}>Transfer Details</p>
            <table style={{ ...styles.detailTable, height: 'auto' }}>
              <tbody>
                {transferRows.map((row, i) => (
                  <tr
                    key={row.label}
                    style={{
                      ...styles.tableRow,
                      borderBottom: i === transferRows.length - 1 ? 'none' : undefined,
                    }}
                  >
                    <td style={styles.tdLabel}>{row.label}</td>
                    <td style={{ ...styles.tdValue, fontWeight: row.bold ? 700 : 600 }}>
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

          </div>

          {/* Transfer Reason */}
          <div style={styles.selectWrap}>
            {currency !== 'INR' ? (
              <select
                onChange={(e) => setReasonForTransfer(e.target.value)}
                value={transferReason}
                style={styles.select}
              >
                <option value="">Select Transfer Reason</option>
                {transferReasons && transferReasons.map((option) => (
                  <option key={option.id} value={option.reason}>{option.reason}</option>
                ))}
              </select>
            ) : (
              <select
                onChange={(e) => setReasonForTransfer(e.target.value)}
                value={transferReason}
                style={styles.select}
              >
                <option value="">Select Transfer Reason</option>
                {userType === 'individual'
                  ? Constants.INR_INDIVIDUAL_REASONS.map((option) => (
                      <option key={option.id} value={option.code + '_' + option.display_name}>
                        {option.display_name}
                      </option>
                    ))
                  : Constants.INR_BUSINESS_REASONS.map((option) => (
                      <option key={option.id} value={option.code + '_' + option.display_name}>
                        {option.display_name}
                      </option>
                    ))}
              </select>
            )}
            <div style={styles.selectArrow} />
          </div>

          {/* Payment Reference */}
          <input
            type="text"
            value={ref}
            onChange={(e) => {
              const value = e.target.value;

              // Allow letters, numbers, spaces and hyphens only
              if (/^[A-Za-z0-9. -]*$/.test(value)) {
                setRef(value);
              }
            }}
            placeholder={currency === 'GBP' ? 'Enter Payment Reference (Required)' : 'Enter Payment Reference (Optional)'}
            maxLength={35}
            style={styles.inputField}
          />

          {Nav_node !== 2 && (
            <input
              type="text"
              placeholder="Enter your notes"
              onChange={(e) => setNotes(e.target.value)}
              style={{ ...styles.inputField, display: 'none' }}
            />
          )}

          {/* Upload Documents */}
          <div style={styles.uploadRow}>
            <button onClick={handleFileUpload} style={styles.uploadLink}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#2463CD" strokeWidth="1.5">
                <path d="M8 11V3M5 6l3-3 3 3" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 12v1a1 1 0 001 1h10a1 1 0 001-1v-1" strokeLinecap="round" />
              </svg>
              Upload Documents
            </button>

          </div>

          {files.map((f, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: '1px solid #E2E6ED',
                borderRadius: 12,
                padding: '16px 20px',
                background: '#FFFFFF',
                width: '624px',
                boxSizing: 'border-box',
                minHeight: '72px',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#1D2338', lineHeight: '140%' }}>
                  {f.name}
                </span>
                <span style={{ fontSize: 12, fontWeight: 400, color: '#676F7D', lineHeight: '140%' }}>
                  {f.size ? `${(f.size / (1024 * 1024)).toFixed(0)}MB` : ''}&nbsp;&nbsp;(Format: JPG, PNG, PDF&nbsp;&nbsp;max- 8MB)
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              
                <button
                  onClick={() => setFiles((prev) => prev.filter((_, idx) => idx !== i))}
                  style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="#E03E3E" strokeWidth="1.4">
                    <polyline points="3,5 15,5" strokeLinecap="round" />
                    <path d="M7 5V3h4v2" strokeLinecap="round" strokeLinejoin="round" />
                    <rect x="4" y="5" width="10" height="10" rx="1.5" />
                    <line x1="7" y1="8" x2="7" y2="13" strokeLinecap="round" />
                    <line x1="11" y1="8" x2="11" y2="13" strokeLinecap="round" />
                  </svg>
                  <span style={{ color: '#E03E3E', fontSize: 14, fontWeight: 600 }}>Delete</span>
                </button>
              </div>
            </div>
          ))}

          <input
            type="file"
            onChange={handleSingleFileChange}
            ref={fileInputRef}
            style={{ display: 'none' }}
          />

        </div>
      </div>

      {/* Confirm Button */}
      <button
        onClick={isFormReady && !buttonLoading ? confirmHandler : undefined}
        disabled={buttonLoading || !isFormReady}
        style={{
          ...styles.confirmBtn,
          background: buttonLoading ? '#ccc' : isFormReady ? '#D26521' : '#CCCCCC',
          cursor: buttonLoading || !isFormReady ? 'not-allowed' : 'pointer',
          boxShadow: isFormReady ? '0px 8px 20px 0px #9E450829' : 'none',
        }}
      >
        {buttonLoading ? (
          'Processing...'
        ) : (
          <>
            <span>Confirm To Proceed</span>
            <ArrowRight className="w-5 h-5 -ml-2.5" />
          </>
        )}
      </button>

      {/* Secure Banner */}
      <div style={styles.secureBanner}>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0, marginTop: 1 }}>
          <rect x="3" y="7" width="12" height="9" rx="2" fillOpacity="0.3" stroke="#9E4508" strokeWidth="1.2" />
          <path d="M6 7V5a3 3 0 0 1 6 0v2" stroke="#9E4508" strokeWidth="1.2" strokeLinecap="round" />
          <circle cx="9" cy="11.5" r="1" fill="#9E4508" />
        </svg>
        <div style={{ height: '68px', width: '592px', gap: '8px' }}>
          <p style={styles.secureTitle}>100% Secure &amp; Safe</p>
          <p style={styles.secureSub}>Your money is protected with bank-level encryption. We never store your banking credentials.</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    backgroundImage: 'linear-gradient(to bottom, #f8fafc 0%, #eff6ff4d 50%, #eef2ff66 100%)',
    backgroundColor: '#ffffff',
    minHeight: '100vh',
    padding: '48px 32px 32px',
    maxWidth: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    boxSizing: 'border-box',
    alignItems: 'center',
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: '16px',
    color: '#1D2338',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    fontWeight: 700,
    padding: 0,
    marginBottom: 8,
    alignSelf: 'flex-start',
  },
  pageTitle: {
    fontSize: '24px',
    fontWeight: 700,
    color: '#394784',
    textAlign: 'center',
    margin: 0,
    lineHeight: '150%',
    letterSpacing: 0,
  },
  pageSubtitle: {
    fontSize: '16px',
    fontWeight: 400,
    color: '#676F7D',
    textAlign: 'center',
    lineHeight: '140%',
    letterSpacing: 0,
  },
  card: {
    background: '#ffffff',
    borderRadius: 16,
    border: '1px solid #F2F2F2',
    padding: '24px',
    gap: '20px',
    width: '672px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  detailsCard: {
    background: '#FEFEFE',
    borderRadius: 12,
    border: '1px solid #D4DCEB',
    padding: '24px',
    gap: '24px',
    width: '624px',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: '28px',
    background: '#676F7D',
    padding: '12px',
    gap: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    fontWeight: 500,
    color: '#FFFFFF',
    flexShrink: 0,
  },
  recipientName: {
    fontSize: 17,
    fontWeight: 700,
    color: '#1D2338',
    lineHeight: '100%',
    letterSpacing: '0px',
  },
  recipientSub: {
    fontSize: 14,
    fontWeight: 500,
    color: '#8F959F',
    marginTop: 2,
    lineHeight: '100%',
    letterSpacing: '0px',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: '#394784',
    marginBottom: 4,
  },
  detailTable: {
    width: '576px',
    borderCollapse: 'collapse',
    gap: '8px',
    marginTop: '10px',
  },
  tableRow: {
    width: '576px',
    gap: '56px',
  },
  tdLabel: {
    fontSize: '14px',
    fontWeight: '400',
    color: '#676F7D',
    width: '200px',
    minWidth: '200px',
    lineHeight: '140%',
    paddingBottom: '12px',
    verticalAlign: 'top',
  },
  tdValue: {
    fontSize: '14px',
    color: '#1D2338',
    fontWeight: 600,
    lineHeight: '140%',
    paddingBottom: '12px',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    verticalAlign: 'top',
  },
  selectWrap: {
    position: 'relative',
  },
  select: {
    border: '1px solid #E2E6ED',
    borderRadius: '8px',
    padding: '16px',
    fontSize: '16px',
    color: '#1D2338',
    background: '#FFFFFF',
    appearance: 'none',
    cursor: 'pointer',
    outline: 'none',
    fontWeight: 500,
    height: '56px',
    width: '624px',
  },
  selectArrow: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 0,
    height: 0,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: '5px solid #aaa',
    pointerEvents: 'none',
  },
  inputField: {
    width: '624px',
    border: '1px solid #E2E6ED',
    borderRadius: '8px',
    padding: '16px',
    fontSize: 14,
    color: '#4a4a4a',
    background: '#FFFFFF',
    outline: 'none',
    boxSizing: 'border-box',
    height: '56px',
  },
  uploadRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 4,
    height: '20px',
    width: '624px',
    gap: '12px',
  },
  uploadLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 14,
    color: '#306ACE',
    cursor: 'pointer',
    fontWeight: 600,
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
  },
  fileName: {
    fontSize: 12,
    color: '#555',
    background: '#F0F4FF',
    padding: '3px 10px',
    borderRadius: 20,
  },

  confirmBtn: {
    width: 672,
    height: 56,
    padding: '12px 20px',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    backgroundColor: '#9E4508',
    color: '#FFFFFF',
    border: 'none',
    fontSize: 15,
    fontWeight: 600,
    letterSpacing: '0.01em',
    fontFamily: 'inherit',
    boxShadow: '0px 8px 20px 0px #9E450829',
    cursor: 'pointer',
    transition: 'background 0.15s',
  },
  secureBanner: {
    width: 672,
    height: 100,
    backgroundColor: '#F4EBE5',
    borderRadius: 16,
    border: '1px solid #EFDCD0',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
  },
  secureTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: '#203358',
    lineHeight: '140%',
  },
  secureSub: {
    fontSize: 14,
    fontWeight: 400,
    color: '#676F7D',
    lineHeight: '140%',
    marginTop: '6px',
  },
};

export default PaymentConfirmation;